import React from "react";
import { Box } from "@mui/material";

const PublicTemplate = ({ children }) => {
    return (
		<Box sx={{ width: "100%", minHeight: "100vh", textAlign: "center" }}>
			{children}
		</Box>
    )
} 

export default PublicTemplate;
